import React, { useState, useEffect, useRef } from "react";
import { FaSearch, FaTimes } from "react-icons/fa";
import "./WhatsAppChat.css";

const EMOJI_CATEGORIES = [
  {
    id: "smileys",
    name: "Smileys & People",
    icon: "😀",
    emojis: [
      { char: "😀", keywords: ["grinning", "happy", "smile", "face"] },
      { char: "😃", keywords: ["joy", "happy", "smile", "face"] },
      { char: "😄", keywords: ["smile", "laugh", "happy"] },
      { char: "😁", keywords: ["grin", "beam", "happy"] },
      { char: "😆", keywords: ["laugh", "satisfied", "haha"] },
      { char: "😅", keywords: ["sweat", "smile", "nervous"] },
      { char: "😂", keywords: ["joy", "tears", "laugh", "lol"] },
      { char: "🤣", keywords: ["rofl", "rolling", "floor", "laugh"] },
      { char: "😊", keywords: ["blush", "smile", "shy"] },
      { char: "😇", keywords: ["halo", "angel", "innocent"] },
      { char: "🙂", keywords: ["slight", "smile"] },
      { char: "🙃", keywords: ["upside", "down", "silly"] },
      { char: "😉", keywords: ["wink", "flirt"] },
      { char: "😌", keywords: ["relieved", "calm"] },
      { char: "😍", keywords: ["heart", "eyes", "love"] },
      { char: "🥰", keywords: ["hearts", "love", "warm"] },
      { char: "😘", keywords: ["kiss", "love"] },
      { char: "😗", keywords: ["kissing"] },
      { char: "😙", keywords: ["kissing", "smile"] },
      { char: "😚", keywords: ["kissing", "closed", "eyes"] },
      { char: "😋", keywords: ["yum", "delicious", "tongue"] },
      { char: "😛", keywords: ["tongue", "silly"] },
      { char: "😜", keywords: ["tongue", "wink", "silly"] },
      { char: "🤪", keywords: ["zany", "crazy"] },
      { char: "😝", keywords: ["squint", "tongue"] },
      { char: "🤑", keywords: ["money", "dollar", "rich"] },
      { char: "🤗", keywords: ["hug", "hugging"] },
      { char: "🤭", keywords: ["hand", "over", "mouth", "oops"] },
      { char: "🤫", keywords: ["shh", "quiet", "silence"] },
      { char: "🤔", keywords: ["thinking", "think", "ponder"] },
      { char: "🤐", keywords: ["zipper", "mouth", "secret"] },
      { char: "🤨", keywords: ["eyebrow", "skeptical"] },
      { char: "😐", keywords: ["neutral", "poker"] },
      { char: "😑", keywords: ["expressionless"] },
      { char: "😶", keywords: ["no", "mouth", "silent"] },
      { char: "😏", keywords: ["smirk", "sly"] },
      { char: "😒", keywords: ["unamused", "annoyed"] },
      { char: "🙄", keywords: ["eyes", "roll"] },
      { char: "😬", keywords: ["grimace", "awkward"] },
      { char: "😮‍💨", keywords: ["sigh", "relief", "exhale"] },
      { char: "🤥", keywords: ["lying", "pinocchio"] },
      { char: "😔", keywords: ["pensive", "sad"] },
      { char: "😪", keywords: ["sleepy"] },
      { char: "🤤", keywords: ["drool"] },
      { char: "😴", keywords: ["sleeping", "zzz"] },
      { char: "😷", keywords: ["mask", "sick"] },
      { char: "🤒", keywords: ["thermometer", "fever"] },
      { char: "🤕", keywords: ["bandage", "hurt"] },
      { char: "🤢", keywords: ["nauseated", "sick"] },
      { char: "🤮", keywords: ["vomit", "puke"] },
      { char: "🤧", keywords: ["sneeze"] },
      { char: "🥵", keywords: ["hot", "sweat"] },
      { char: "🥶", keywords: ["cold", "freezing"] },
      { char: "🥴", keywords: ["woozy", "drunk"] },
      { char: "😵", keywords: ["dizzy"] },
      { char: "🤯", keywords: ["mind", "blown", "exploding"] },
      { char: "🤠", keywords: ["cowboy"] },
      { char: "🥳", keywords: ["party", "celebrate"] },
      { char: "😎", keywords: ["cool", "sunglasses"] },
      { char: "🤓", keywords: ["nerd", "geek"] },
      { char: "🧐", keywords: ["monocle", "inspect"] },
    ],
  },
  {
    id: "hands",
    name: "Hands & Gestures",
    icon: "👍",
    emojis: [
      { char: "👍", keywords: ["thumbs", "up", "like", "ok", "yes", "good"] },
      { char: "👎", keywords: ["thumbs", "down", "dislike", "no", "bad"] },
      { char: "👌", keywords: ["ok", "perfect", "good"] },
      { char: "✌️", keywords: ["victory", "peace", "two"] },
      { char: "🤞", keywords: ["crossed", "fingers", "luck"] },
      { char: "🤟", keywords: ["love", "you", "gesture"] },
      { char: "🤘", keywords: ["rock", "horns"] },
      { char: "🤙", keywords: ["call", "me", "shaka"] },
      { char: "👈", keywords: ["point", "left"] },
      { char: "👉", keywords: ["point", "right"] },
      { char: "👆", keywords: ["point", "up"] },
      { char: "👇", keywords: ["point", "down"] },
      { char: "☝️", keywords: ["point", "up", "one"] },
      { char: "✋", keywords: ["hand", "stop", "five"] },
      { char: "🤚", keywords: ["back", "of", "hand"] },
      { char: "🖐️", keywords: ["hand", "splayed", "five"] },
      { char: "🖖", keywords: ["vulcan", "spock"] },
      { char: "👋", keywords: ["wave", "hello", "bye"] },
      { char: "💪", keywords: ["bicep", "muscle", "strong", "power"] },
      { char: "🙏", keywords: ["pray", "please", "thanks", "namaste"] },
      { char: "🤝", keywords: ["handshake", "deal", "agree"] },
      { char: "👏", keywords: ["clap", "applause", "bravo"] },
      { char: "🙌", keywords: ["raise", "hands", "celebration"] },
      { char: "👐", keywords: ["open", "hands"] },
      { char: "🤲", keywords: ["cupped", "hands"] },
      { char: "✍️", keywords: ["writing", "hand", "write"] },
      { char: "💅", keywords: ["nail", "polish"] },
      { char: "🤳", keywords: ["selfie"] },
    ],
  },
  {
    id: "hearts",
    name: "Hearts & Emotions",
    icon: "❤️",
    emojis: [
      { char: "❤️", keywords: ["red", "heart", "love"] },
      { char: "🧡", keywords: ["orange", "heart"] },
      { char: "💛", keywords: ["yellow", "heart"] },
      { char: "💚", keywords: ["green", "heart"] },
      { char: "💙", keywords: ["blue", "heart"] },
      { char: "💜", keywords: ["purple", "heart"] },
      { char: "🖤", keywords: ["black", "heart"] },
      { char: "🤍", keywords: ["white", "heart"] },
      { char: "🤎", keywords: ["brown", "heart"] },
      { char: "💔", keywords: ["broken", "heart"] },
      { char: "❣️", keywords: ["heart", "exclamation"] },
      { char: "💕", keywords: ["two", "hearts"] },
      { char: "💞", keywords: ["revolving", "hearts"] },
      { char: "💓", keywords: ["beating", "heart"] },
      { char: "💗", keywords: ["growing", "heart"] },
      { char: "💖", keywords: ["sparkling", "heart"] },
      { char: "💘", keywords: ["heart", "arrow"] },
      { char: "💝", keywords: ["heart", "ribbon"] },
      { char: "🔥", keywords: ["fire", "hot", "flame", "lit"] },
      { char: "✨", keywords: ["sparkles", "magic", "clean", "star"] },
      { char: "🌟", keywords: ["glowing", "star"] },
      { char: "💫", keywords: ["dizzy", "star"] },
      { char: "💥", keywords: ["boom", "collision", "explosion"] },
      { char: "💯", keywords: ["hundred", "100", "perfect"] },
      { char: "💢", keywords: ["anger", "symbol"] },
      { char: "💨", keywords: ["dash", "wind", "fast"] },
      { char: "💦", keywords: ["sweat", "water", "drops"] },
    ],
  },
  {
    id: "business",
    name: "Objects & Business",
    icon: "💼",
    emojis: [
      { char: "💼", keywords: ["briefcase", "work", "business"] },
      { char: "📊", keywords: ["bar", "chart", "analytics", "report"] },
      { char: "📈", keywords: ["chart", "increasing", "growth", "profit"] },
      { char: "📉", keywords: ["chart", "decreasing", "loss"] },
      { char: "📋", keywords: ["clipboard", "list", "document"] },
      { char: "📑", keywords: ["bookmark", "tabs", "file"] },
      { char: "📁", keywords: ["file", "folder"] },
      { char: "📂", keywords: ["open", "folder"] },
      { char: "📅", keywords: ["calendar", "date", "schedule"] },
      { char: "📆", keywords: ["tear", "calendar"] },
      { char: "📝", keywords: ["memo", "note", "pencil"] },
      { char: "📞", keywords: ["telephone", "receiver", "call", "phone"] },
      { char: "📱", keywords: ["mobile", "phone", "smartphone"] },
      { char: "💬", keywords: ["speech", "balloon", "chat", "message"] },
      { char: "💭", keywords: ["thought", "balloon", "think"] },
      { char: "✉️", keywords: ["envelope", "email", "mail"] },
      { char: "📧", keywords: ["e-mail", "mail", "send"] },
      { char: "📩", keywords: ["incoming", "envelope"] },
      { char: "📨", keywords: ["incoming", "mail"] },
      { char: "🏷️", keywords: ["label", "tag", "price"] },
      { char: "💳", keywords: ["credit", "card", "payment", "bank"] },
      { char: "💵", keywords: ["dollar", "cash", "money", "banknote"] },
      { char: "💰", keywords: ["money", "bag", "cash"] },
      { char: "💸", keywords: ["money", "wings", "payment"] },
      { char: "🏦", keywords: ["bank", "building", "finance"] },
      { char: "✈️", keywords: ["airplane", "flight", "travel", "ticket"] },
      { char: "🎫", keywords: ["ticket", "pass", "entry"] },
      { char: "🎟️", keywords: ["admission", "tickets"] },
      { char: "🚗", keywords: ["car", "auto", "vehicle"] },
      { char: "🏨", keywords: ["hotel", "building", "stay"] },
      { char: "🌍", keywords: ["globe", "earth", "world"] },
      { char: "📌", keywords: ["pushpin", "pin", "location"] },
      { char: "📍", keywords: ["round", "pushpin", "location", "map"] },
      { char: "💡", keywords: ["bulb", "idea", "light"] },
      { char: "🔑", keywords: ["key", "lock", "access"] },
      { char: "🔒", keywords: ["lock", "closed", "security"] },
      { char: "🔓", keywords: ["unlock", "open"] },
    ],
  },
  {
    id: "symbols",
    name: "Symbols & Flags",
    icon: "✅",
    emojis: [
      { char: "✅", keywords: ["check", "mark", "correct", "done", "yes"] },
      { char: "✔️", keywords: ["heavy", "check", "mark"] },
      { char: "❌", keywords: ["cross", "mark", "no", "wrong", "cancel"] },
      { char: "❎", keywords: ["negative", "squared", "cross"] },
      { char: "➕", keywords: ["plus", "add"] },
      { char: "➖", keywords: ["minus", "subtract"] },
      { char: "❓", keywords: ["question", "help"] },
      { char: "❗", keywords: ["exclamation", "alert", "warning"] },
      { char: "⚠️", keywords: ["warning", "alert", "caution"] },
      { char: "🚫", keywords: ["prohibited", "no", "ban"] },
      { char: "🛑", keywords: ["stop", "sign"] },
      { char: "ℹ️", keywords: ["info", "information"] },
      { char: "🔔", keywords: ["bell", "notification", "alert"] },
      { char: "🔕", keywords: ["bell", "slash", "mute"] },
      { char: "⭐", keywords: ["star", "favorite", "rating"] },
      { char: "🎉", keywords: ["party", "popper", "tada", "congrats"] },
      { char: "🎊", keywords: ["confetti", "ball", "celebration"] },
      { char: "🎁", keywords: ["gift", "present", "offer"] },
      { char: "🇦🇪", keywords: ["flag", "uae", "dubai", "emirates"] },
      { char: "🇸🇦", keywords: ["flag", "saudi", "arabia"] },
      { char: "🇶🇦", keywords: ["flag", "qatar"] },
      { char: "🇴🇲", keywords: ["flag", "oman"] },
      { char: "🇰🇼", keywords: ["flag", "kuwait"] },
      { char: "🇧🇭", keywords: ["flag", "bahrain"] },
      { char: "🇵🇰", keywords: ["flag", "pakistan"] },
      { char: "🇮🇳", keywords: ["flag", "india"] },
      { char: "🇬🇧", keywords: ["flag", "uk", "britain"] },
      { char: "🇺🇸", keywords: ["flag", "usa", "america"] },
    ],
  },
];

const EmojiPicker = ({ onSelectEmoji, onClose }) => {
  const [activeCategory, setActiveCategory] = useState("smileys");
  const [search, setSearch] = useState("");
  const pickerRef = useRef(null);

  // Close picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  // Filter emojis based on search term
  const getFilteredEmojis = () => {
    if (!search.trim()) {
      const cat = EMOJI_CATEGORIES.find((c) => c.id === activeCategory);
      return cat ? cat.emojis : [];
    }

    const term = search.toLowerCase().trim();
    const results = [];
    EMOJI_CATEGORIES.forEach((category) => {
      category.emojis.forEach((emoji) => {
        if (
          emoji.keywords.some((k) => k.includes(term)) ||
          emoji.char.includes(term)
        ) {
          if (!results.some((r) => r.char === emoji.char)) {
            results.push(emoji);
          }
        }
      });
    });
    return results;
  };

  const filteredEmojis = getFilteredEmojis();

  return (
    <div className="wa-emoji-picker-container" ref={pickerRef}>
      {/* Search Header */}
      <div className="wa-emoji-header">
        <div className="wa-emoji-search-box">
          <FaSearch className="wa-emoji-search-icon" />
          <input
            type="text"
            placeholder="Search emoji..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
          {search && (
            <button className="wa-emoji-search-clear" onClick={() => setSearch("")}>
              <FaTimes />
            </button>
          )}
        </div>
      </div>

      {/* Category Tabs (only shown when not searching) */}
      {!search && (
        <div className="wa-emoji-category-tabs">
          {EMOJI_CATEGORIES.map((cat) => (
            <button
              key={cat.id}
              className={`wa-emoji-tab-btn ${
                activeCategory === cat.id ? "active" : ""
              }`}
              onClick={() => setActiveCategory(cat.id)}
              title={cat.name}
            >
              {cat.icon}
            </button>
          ))}
        </div>
      )}

      {/* Emoji Grid */}
      <div className="wa-emoji-body">
        {filteredEmojis.length > 0 ? (
          <div className="wa-emoji-grid">
            {filteredEmojis.map((item, idx) => (
              <button
                key={idx}
                className="wa-emoji-item"
                onClick={() => onSelectEmoji(item.char)}
                title={item.keywords.join(", ")}
              >
                {item.char}
              </button>
            ))}
          </div>
        ) : (
          <div className="wa-emoji-empty">No emojis found</div>
        )}
      </div>
    </div>
  );
};

export default EmojiPicker;
